/**
 * Build discover API params for the home map.
 * Country scope is fetched once; city/service/category filters run client-side
 * so the filter sheet preview count matches what Apply shows.
 */

/**
 * @param {string} browseCountry
 */
export function buildDiscoverRequestParams(browseCountry) {
  return {
    country: browseCountry,
    cities: [],
  };
}
